import React from 'react';
import { motion } from 'framer-motion';
const audiencePoints = [{
  title: 'Preparas uno o varios cursos',
  description: 'Necesitas encontrar el contenido adecuado para cada nivel sin revisar archivos, libros y carpetas durante horas.'
}, {
  title: 'Tus tardes se van en planificar',
  description: 'Buscas materiales ya pensados para imprimir, adaptar a tu grupo y usar sin empezar con una hoja en blanco.'
}, {
  title: 'Tus estudiantes se pierden con la teoría sola',
  description: 'Quieres explicar átomos, enlaces, compuestos, reacciones y cálculos con apoyos visuales, ejemplos y consignas claras.'
}, {
  title: 'Necesitas actividades diferentes',
  description: 'Quieres salir de las guías repetidas y proponer desafíos, juegos, análisis y situaciones que inviten a participar.'
}, {
  title: 'Quieres evaluar con más orden',
  description: 'Necesitas versiones A y B, propuestas de práctica y recursos que faciliten el seguimiento y la recuperación.'
}];
export function WhoItsFor() {
  return <section className="py-8 md:py-16 px-4" data-id="element-278" data-mp="1vodg97dkavn1">
      <div className="max-w-6xl mx-auto" data-id="element-279" data-mp="1von6mw2ir4t9">
        <div className="max-w-4xl mx-auto text-center mb-6 md:mb-10" data-id="element-280" data-mp="1qxeuhs9t15ce">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-2xl md:text-4xl font-black text-chem-navy leading-tight mb-3 md:mb-4" data-id="element-281" data-mp="1qvk6g538kx43">
            Química Visual fue creado para docentes que quieren enseñar mejor
            sin dedicar más horas a planificar.
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-chem-navy/70 font-bold text-sm md:text-lg leading-relaxed" data-id="element-282" data-mp="180n6x6n8c42j">
            Si das Química en educación secundaria, sabes que una buena clase no
            se resuelve solo con una explicación: necesitas ejemplos,
            actividades, práctica, evaluación, alternativas para recuperar y
            recursos que ayuden a tus estudiantes a comprender lo que ven.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-283" data-mp="3cg8t5c36kbpd">
          {audiencePoints.map((point, index) => <motion.article key={point.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.06
        }} className="bg-white border border-chem-petrol/12 rounded-3xl p-5 md:p-6 shadow-lg shadow-chem-navy/5 flex flex-col" data-id="element-284" data-mp="42076mv5yj66" data-mpi={index}>
              <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-chem-petrol text-white text-xs font-black mb-4" data-id="element-285" data-mp="2erp2bcu35mu5">
                {String(index + 1).padStart(2, '0')}
              </span>
              <h3 className="text-chem-navy font-black text-base md:text-lg leading-tight mb-2" data-id="element-286" data-mp="2c6r1zs41vum9">
                {point.title}
              </h3>
              <p className="text-chem-navy/65 font-medium text-sm leading-relaxed" data-id="element-287" data-mp="2l8qfwbjrqikz">
                {point.description}
              </p>
            </motion.article>)}
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto mt-6 md:mt-10 text-center text-chem-petrol font-black text-lg md:text-2xl leading-snug" data-id="element-288" data-mp="1skb746r8cwi3">
          Tu próxima clase no tiene que empezar con una búsqueda interminable ni
          con otra noche creando material.
        </motion.p>
      </div>
    </section>;
}